import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { HardHatIcon, PackageIcon, TruckIcon, FactoryIcon, StoreIcon, HeartIcon, ArrowRightIcon } from 'lucide-react';
import { applications } from '../data/applications';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
interface ApplicationsPageProps {
  onRequestQuote: () => void;
}
export function ApplicationsPage({
  onRequestQuote
}: ApplicationsPageProps) {
  const iconMap: Record<string, ComponentType<{
    className?: string;
  }>> = {
    HardHat: HardHatIcon,
    Package: PackageIcon,
    Truck: TruckIcon,
    Factory: FactoryIcon,
    Store: StoreIcon,
    Heart: HeartIcon
  };
  return <main className="min-h-screen bg-dark-bg" data-id="element-550">
      {/* Hero */}
      <section className="py-20 bg-dark-surface border-b-2 border-dark-border" data-id="element-551">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-552">
          <h1 className="text-5xl md:text-6xl font-black text-white mb-6" data-id="element-553">
            <span className="text-brand-yellow" data-id="element-554">Primene</span> u različitim
            industrijama
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-555">
            D-TECH oprema rešava realne izazove u različitim profesionalnim
            okruženjima. Otkrijte kako naša rešenja mogu unaprediti vaše
            operacije.
          </p>
        </div>
      </section>

      {/* Applications Grid */}
      <section className="py-20" data-id="element-556">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-557">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-558">
            {applications.map(app => {
            const Icon = iconMap[app.icon] || PackageIcon;
            return <Card key={app.id} hover data-id="element-559">
                  <div className="flex items-start space-x-4 mb-6" data-id="element-560">
                    <div className="w-14 h-14 bg-brand-yellow rounded-industrial flex items-center justify-center flex-shrink-0" data-id="element-561">
                      <Icon className="w-7 h-7 text-dark-bg" data-id="element-562" />
                    </div>
                    <div className="flex-1" data-id="element-563">
                      <h3 className="text-2xl font-bold text-white mb-2" data-id="element-564">
                        {app.title}
                      </h3>
                    </div>
                  </div>
                  <div className="space-y-4" data-id="element-565">
                    <div data-id="element-566">
                      <h4 className="text-sm font-bold text-gray-400 uppercase tracking-wider mb-2" data-id="element-567">
                        Problem
                      </h4>
                      <p className="text-gray-300 leading-relaxed" data-id="element-568">
                        {app.problem}
                      </p>
                    </div>
                    <div data-id="element-569">
                      <h4 className="text-sm font-bold text-brand-yellow uppercase tracking-wider mb-2" data-id="element-570">
                        Rešenje
                      </h4>
                      <p className="text-white leading-relaxed" data-id="element-571">
                        {app.solution}
                      </p>
                    </div>
                  </div>
                </Card>;
          })}
          </div>

          {/* CTA Section */}
          <div className="bg-dark-surface border-2 border-dark-border rounded-industrial p-12 text-center" data-id="element-572">
            <h2 className="text-3xl font-black text-white mb-4" data-id="element-573">
              Ne vidite vašu industriju?
            </h2>
            <p className="text-xl text-gray-400 mb-8 max-w-2xl mx-auto" data-id="element-574">
              Naša oprema se prilagođava različitim profesionalnim okruženjima.
              Kontaktirajte nas da razgovaramo o vašoj specifičnoj primeni.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-575">
              <Button variant="primary" size="lg" onClick={onRequestQuote} data-id="element-576">
                Zatražite ponudu
              </Button>
              <Link to="/contact" data-id="element-577">
                <Button variant="secondary" size="lg" data-id="element-578">
                  Kontaktirajte nas
                  <ArrowRightIcon className="w-5 h-5 ml-2 inline" data-id="element-579" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>;
}